import { DBOperationError, TableNotExist } from '../error';
export function getCollectionSchema(tableName, schema) {
    var collectionSchemas = schema.collections.filter(function (col) { return col.name === tableName; });
    if (!collectionSchemas.length) {
        throw new TableNotExist(tableName);
    }
    return collectionSchemas[0];
}
export function assertResp(resp, optName, dbErrorObserver) {
    if (resp.err_code || resp.err_msg) {
        var error = new DBOperationError("has error in " + optName + " opt, code: " + resp.err_code + " msg: " + resp.err_msg);
        dbErrorObserver === null || dbErrorObserver === void 0 ? void 0 : dbErrorObserver(error);
        throw error;
    }
}
//# sourceMappingURL=common.js.map